module.exports = __webpack_public_path__ + "img/icon-pptdownload.53076e63.svg";